import React from 'react'

const Divider = () => {
  return <div aria-hidden className="w-full border-t border-grey-tertiary-10" />
}

export default Divider
